import { render } from "./ThankYou.vue?vue&type=template&id=ea70578a&scoped=true&bindings={}"
import script from "./ThankYou.vue?vue&type=script&lang=ts"
export * from "./ThankYou.vue?vue&type=script&lang=ts"

import "./ThankYou.vue?vue&type=style&index=0&id=ea70578a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ea70578a"

export default script